/* eslint-disable jsx-a11y/media-has-caption */
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, makeStyles, Theme, Tabs, Tab } from '@material-ui/core';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useHistory } from 'react-router-dom';

import { Button } from '../../../../../shared/components/Button';
import { Input } from '../../../../../shared/components/Form/Input';
import { PageContainer } from '../../../../../shared/components/PageContainer';
import { useSnackMessages } from '../../../../../shared/hooks/useSnackMessages';
import { api } from '../../../../../shared/services/apiClient';
import { UploadImage } from '../../../components/UploadImage';
import { IForm } from '../types';
import { schema } from './schema';

export function BlogCreate() {
  const useStyles = makeStyles((theme: Theme) => ({
    field: {
      borderRadius: '4px',
      height: '200px',
      [theme.breakpoints.down(524)]: {
        height: '230px',
      },
    },
  }));
  const classes = useStyles();
  const history = useHistory();
  const { msgSuccess, msgError } = useSnackMessages();

  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [videoUrl, setVideoUrl] = useState('');

  // 0 = imagem, 1 = video
  const [mediaTab, setMediaTab] = useState(0);

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: {
      title: '',
      description: '',
      videoUrl: '',
    },
  });

  const onSubmit = useCallback(
    async ({ title }: IForm) => {
      try {
        // ------------------------------------------------------
        // SE A ABA FOR VÍDEO → NÃO FAZ UPLOAD DE IMAGEM
        // ------------------------------------------------------
        if (mediaTab === 1) {
          await api.post('/admin/blog', {
            title,
            description,
            url: videoUrl,
          });

          msgSuccess('Post cadastrado com sucesso!');
          history.push('/blog');
          return;
        }

        // ------------------------------------------------------
        // SE FOR IMAGEM → LÓGICA NORMAL
        // ------------------------------------------------------
        if (file) {
          const formDataFile = new FormData();
          formDataFile.append('blog', file);

          const response = await api.post('/admin/blog/image', formDataFile);

          if (response.data) {
            await api.post('/admin/blog', {
              description,
              title,
              image: response.data?.fileName,
            });

            setFile(undefined);
            msgSuccess('Post cadastrado com sucesso!');
            history.push('/blog');
          }
        } else {
          await api.post('/admin/blog', {
            description,
            title,
          });

          msgSuccess('Post cadastrado com sucesso!');
          history.push('/blog');
        }
      } catch (error: any) {
        setLoading(false);
        msgError(error?.response?.data?.message);
      }
    },
    [mediaTab, file, videoUrl, description, msgSuccess, msgError, history]
  );

  return (
    <PageContainer component="form" onSubmit={handleSubmit(onSubmit)}>
      {/* -------------------------- */}
      {/* TABS */}
      {/* -------------------------- */}
      <Tabs
        value={mediaTab}
        onChange={(_, v) => setMediaTab(v)}
        indicatorColor="primary"
        textColor="primary"
        style={{ marginBottom: 20 }}
      >
        <Tab label="Imagem" />
        <Tab label="Vídeo" />
      </Tabs>

      {/* -------------------------- */}
      {/* CONTEÚDO DA ABA */}
      {/* -------------------------- */}
      <Box display="flex" flexDirection="column" mb={3} width="100%">
        {mediaTab === 0 && (
          <>
            <Box mb={2}>
              A <strong>Imagem</strong> será <strong>redimensionada</strong> com
              tamanho máximo de <strong>800</strong>px largura ×{' '}
              <strong>600</strong>px altura.
            </Box>

            <UploadImage onFile={(value) => setFile(value)} />
          </>
        )}

        {mediaTab === 1 && (
          <Input
            name="videoUrl"
            label="Link do vídeo (YouTube)"
            control={control}
            variant="outlined"
            fullWidth
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            required
            style={{ marginBottom: 16 }}
          />
        )}

        <Input
          name="title"
          control={control}
          error={errors}
          label="Título"
          variant="outlined"
          fullWidth
          disabled={isSubmitting}
          required
          style={{ marginBottom: 16 }}
        />

        <fieldset className={classes.field}>
          <legend style={{ marginBottom: '10px' }}>Descrição:</legend>
          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
            style={{
              minHeight: '100px',
              backgroundColor: 'none',
              marginLeft: '10px',
              marginRight: '10px',
              height: '100px',
            }}
            placeholder="500 caracteres"
          />
        </fieldset>
      </Box>

      <Box display="flex" justifyContent="flex-end">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isSubmitting || loading}
          size="large"
        >
          Salvar
        </Button>
      </Box>
    </PageContainer>
  );
}
